import { connect } from 'react-redux';

import { MainContacts, IMainContactsProps } from './MainContacts';
import { IState } from '../../store';
import { trackingPhoneEvent } from '../../store/tracking/mobile';
import { TTypedThunkDispatch } from '../../types/store';

type TMainContactsContainerStoreProps = Pick<IMainContactsProps, 'phone' | 'moderationStatus' | 'displayPhone'>;

type TMainContactsContainerDispatchProps = Pick<IMainContactsProps, 'trackShowPhoneClick'>;

export function mapStateToProps(state: IState): TMainContactsContainerStoreProps {
  const { village } = state.villageData;

  return {
    displayPhone: village && village.builder?.displayPhone,
    moderationStatus: village && village.builder?.moderationStatus,
    phone: village && village.builder?.phone,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TMainContactsContainerDispatchProps {
  return {
    trackShowPhoneClick() {
      dispatch(trackingPhoneEvent('Open_KP_card_blockMore'));
    },
  };
}

export const MainContactsContainer = connect<TMainContactsContainerStoreProps, TMainContactsContainerDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(MainContacts);
